import React, { Component, lazy, Suspense } from "react";
import { useEffect, useState } from "react";
// import HeroPage from "../hero";
// import NewLayanan from "../services";
// import AboutUsPage from "../about";
// import ContactPage from "../contact";
// import Tim from "../tim";
// import SamplePortfolioPage from "../project";
import { Helmet } from "react-helmet";
import Headers from "../../components/header/header";
import ToTop from "../../components/totop/toptop";
import { Link as ScrollLink, Element } from 'react-scroll';

const HeroPage = lazy(() => import('../hero'));
const AboutPage = lazy(() => import('../about'));
const ServicePage = lazy(() => import('../services'));
const PortfolioPage = lazy(() => import('../project'));
const TeamPage = lazy(() => import('../tim'));
const ContactPage = lazy(() => import('../contact'));

export default function MainPage() {
    const [theme, setTheme] = useState(() => {
        const savedTheme = localStorage.getItem('Dark_Mode');
        return savedTheme ? savedTheme : "light";
    });

    const handleTheme = (newValue) => {
        setTheme(newValue);
    }

    useEffect(() => {
        const data = window.localStorage.getItem('Dark_Mode')
        if (data !== null) setTheme(JSON.parse(data))
    }, []);

    useEffect(() => {
        const sections = document.querySelectorAll("section");
        const navLi = document.querySelectorAll("nav ul li");

        window.addEventListener("scroll", () => {
            let current;
            sections.forEach(section => {
                const sectionTop = section.offsetTop;
                const sectionHeight = section.clientHeight;
                if (window.scrollY >= sectionTop - sectionHeight / 3) {
                    current = section.getAttribute('id');
                }
            });
            navLi.forEach(li => {
                li.classList.remove('link-active');
                if (li.classList.contains(current)) {
                    li.classList.add('link-active')
                }
            });
        });
    }, []);

    return (
        <>
            <Helmet>
                <title>Alcott Software Company</title>
            </Helmet>
            <div id={theme} className="relative">
                <div className="contentx relative">
                    <Headers onThemeChange={(value) => handleTheme(value)} theme={theme} />
                    <HeroPage />
                    <Element name="about">
                        <AboutPage />
                    </Element>
                    <Element name="services">
                        <ServicePage theme={theme} />
                    </Element>
                    <Element name="project">
                        <PortfolioPage />
                    </Element>
                    <Element name="team">
                        <TeamPage />
                    </Element>
                    <Element name="contact">
                        <ContactPage />
                    </Element>
                </div>
                <ToTop />
            </div>
        </>
    )
}
